import React from 'react'
import {useState} from 'react'
import {AppDataContext} from '../context/Contexts'
//import { useInView } from 'react-intersection-observer'
import '../index.css'


import Product from "./Product";


export default function App() {
    const [appData, setAppData] = useState({
        step: 1, seat: undefined, color: 'Black',
        check: undefined, product: undefined, trim: '', has_trims: false,
        with_bonus: false,
        year: '', make: '', model: ''
    });

    return (
        <AppDataContext.Provider value={{currentAppData: appData, setCurrentAppData: setAppData}}>
            <div className={`products-listing`}>
                <div>
                    <Product/>
                    {process.env.NODE_ENV === 'development' ? (
                        <p>
                            <strong>Notice:</strong> You are currently running React in
                            development mode. Rendering performance will be slightly degraded
                            until this application is build for production.
                        </p>
                    ) : null}
                </div>
            </div>
        </AppDataContext.Provider>
    )
}
